// extracted by mini-css-extract-plugin
export default {"centerByMean":"CenterByMean_centerByMean__97Os+"};